
import FamilyMdl from '@/models/Warehouse/WhFamily'
import {
    generateFetchDataFunction,
    generateDeleteItemFunction,
} from '../DataTableService'

// const includes = ['sl_wholesale_discounts']
// const appends = ['sale_prices', 'stocks']

const dtFetchData = generateFetchDataFunction(FamilyMdl)
const dtDeleteItem = generateDeleteItemFunction(FamilyMdl)
// If we need a custom route for the show and edit view:
// const showEditRoute = 'custom_route'

export default {
    dtFetchData,
    dtDeleteItem,
    //showEditRoute
}
